import { Directive } from '@angular/core';

@Directive({
  selector: '[libContainerPalletKpi]'
})
export class ContainerPalletKpiDirective {}
